/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
document.addEventListener("DOMContentLoaded", function(event) {
    activarGaleriaControls();
});


function activarGaleriaControls(){
    document.currentPost = 0;
    document.totalPosts = document.querySelectorAll('.bloque-estudio-galeria .post');
    // console.log(document.currentPost);
    if(document.totalPosts.length > 0){
        document.totalPosts = document.totalPosts.length;
        // next
        let $nextControl = document.querySelector('.bloque-estudio-galeria .controls .next');
        if($nextControl){
            $nextControl.addEventListener('click', function(){
                if(document.currentPost < document.totalPosts-1){
                    $nextPost = document.querySelectorAll('.bloque-estudio-galeria .post')[document.currentPost+1];
                    var moveX = $nextPost.offsetWidth;
                    
                    $posts = document.querySelector('.bloque-estudio-galeria .posts');
                    const style= getComputedStyle($posts);
                    const itemRightpadding = parseInt(style.paddingRight);
                    
                    $posts.scrollLeft += moveX + itemRightpadding; 

                    document.currentPost++;
                }
            });
                
            // }
        }

        // prev
        let $prevControl = document.querySelector('.bloque-estudio-galeria .controls .prev');
        if($prevControl){
            $prevControl.addEventListener('click', function(){
                if(document.currentPost > 0){
                    $prevPost = document.querySelectorAll('.bloque-estudio-galeria .post')[document.currentPost-1];
                    var moveX = $prevPost.offsetWidth;
                    
                    $posts = document.querySelector('.bloque-estudio-galeria .posts');
                    const style= getComputedStyle($posts);
                    const itemRightpadding = parseInt(style.paddingRight);
                    
                    $posts.scrollLeft -= moveX - itemRightpadding; 

                    document.currentPost--;
                }
            });
                
            // }
        }        
    }
}

/* eslint-enable no-console */
